import i18n, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import aiAdminPtBR from './locales/pt-BR/ai-admin.json' with { type: 'json' };
import aiClinicPtBR from './locales/pt-BR/ai-clinic.json' with { type: 'json' };
import authPtBR from './locales/pt-BR/auth.json' with { type: 'json' };
import clinicsPtBR from './locales/pt-BR/clinics.json' with { type: 'json' };
import commonPtBR from './locales/pt-BR/common.json' with { type: 'json' };
import dashboardPtBR from './locales/pt-BR/dashboard.json' with { type: 'json' };
import validationPtBR from './locales/pt-BR/validation.json' with { type: 'json' };

/** Namespaces carregados por padrão. Um novo módulo adiciona seu ns aqui. */
export const defaultNamespaces = [
  'common',
  'auth',
  'validation',
  'ai-admin',
  'ai-clinic',
  'dashboard',
  'clinics',
] as const;
export type Namespace = (typeof defaultNamespaces)[number];

/** Idiomas suportados. Estrutura pronta; apenas pt-BR ativo hoje. */
export const supportedLanguages = ['pt-BR'] as const;
export type Language = (typeof supportedLanguages)[number];

export const defaultLanguage: Language = 'pt-BR';

/** Cria e retorna uma instância já inicializada do i18next + react-i18next.
 * Em apps (web, patient, etc) basta importar `i18n` de `@kmgestao/i18n`. */
export function createI18n(): I18nInstance {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources: {
        'pt-BR': {
          common: commonPtBR,
          auth: authPtBR,
          validation: validationPtBR,
          'ai-admin': aiAdminPtBR,
          'ai-clinic': aiClinicPtBR,
          dashboard: dashboardPtBR,
          clinics: clinicsPtBR,
        },
      },
      lng: defaultLanguage,
      fallbackLng: defaultLanguage,
      defaultNS: 'common',
      ns: defaultNamespaces as unknown as string[],
      interpolation: { escapeValue: false },
      returnNull: false,
      react: { useSuspense: false },
    });
  }
  return i18n;
}

/** Instância singleton compartilhada pelos apps. */
export const i18nInstance = createI18n();
